export default __webpack_public_path__ + "static/media/theme_sommer.e5056da0.jpg";